export var E_LABS_NAME;
(function (E_LABS_NAME) {
    E_LABS_NAME["PATENT_COLOR"] = "PATENT_COLOR";
    E_LABS_NAME["PATENT_WORD_CLOUD"] = "PATENT_WORD_CLOUD";
    E_LABS_NAME["WORKSPACE_LITE_TABLE"] = "WORKSPACE_LITE_TABLE";
    E_LABS_NAME["DEEP_VIEW"] = "DEEP_VIEW";
    E_LABS_NAME["HI_RES_IMAGE"] = "HI_RES_IMAGE";
})(E_LABS_NAME || (E_LABS_NAME = {}));
